import {FC} from 'react'
import {Presenter} from './Presenter'

export const Request: FC = () => <Presenter />
